/*
 * Module for touchPoint select piece of the cancel action labels administration
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./touchPointSelectDisplayView",
], function (Marionette, Backbone, Messenger, TouchPointSelectDisplayView) {
  var TouchPointSelectDisplayController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "touchPointSelectDisplayModule";
      this.region = options.region;
    },
    show: function (touchPoints, defaultTouchPoint) {
      this.touchPoints = touchPoints;
      this.touchPoints.defaultTouchPoint = defaultTouchPoint;
      this.view = new TouchPointSelectDisplayView.touchPointSelectView({ collection: touchPoints });
      this.view.on(
        "touchPoint:changed",
        function (touchPointId) {
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("change:selected:touchPoint", touchPointId);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.view);
    },
    _showSubViews: function () {},
  });

  return TouchPointSelectDisplayController;
});
